//# sourceMappingURL=fonts.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/fonts/fonts.interface.js
// module id = 1170
// module chunks = 4